/** Positionsrechnung für jedes Popover (PV-037 verschoben aus befunde/, PV-052 A10). */
/** Breite/Höhe des Popovers und Mindestabstand zum Sichtfeldrand. */
export const POPOVER_BREITE = 360;
export const POPOVER_HOEHE = 420;
const RAND = 8;

/**
 * Sichtfeld-Koordinaten des Befund-Popovers (A10: „wird am Kartenrand nicht abgeschnitten").
 * Rechtsbündig unter dem Anker; passt es unten nicht, darüber. Links/rechts ans Sichtfeld geklemmt.
 */
export function popoverPosition(
  anker: { top: number; bottom: number; left: number; right: number },
  vw: number,
  vh: number,
  breite: number = POPOVER_BREITE,
  hoehe: number = POPOVER_HOEHE,
): { top: number; left: number } {
  const left = Math.max(RAND, Math.min(anker.right - breite, vw - breite - RAND));
  const untenPasst = anker.bottom + 4 + hoehe <= vh - RAND;
  const top = untenPasst ? anker.bottom + 4 : Math.max(RAND, anker.top - 4 - hoehe);
  return { top, left };
}
